import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { SocketIoEvents } from '@/events/socket-io.events';
import {
    usePickedBrandGroupsReconcile,
    usePickedBrandGroupsStorageSync,
    usePickedProductsReconcile,
    useProductSelectionSessionSync,
    useSelectionSessionBootstrap,
} from '@/context/reviews-page-transport-selection.effects';
import {
    useClientReviewsSyncRefetch,
    useRefetchOnSelectionReconcileRevision,
    useReviewAnswerJobDoneSync,
    useReviewFeedItemChangedSync,
} from '@/context/reviews-page-transport-realtime.effects';

export {
    usePickedBrandGroupsReconcile,
    usePickedBrandGroupsStorageSync,
    usePickedProductsReconcile,
    useProductSelectionSessionSync,
    useSelectionSessionBootstrap,
} from '@/context/reviews-page-transport-selection.effects';
export {
    useClientReviewsSyncRefetch,
    useRefetchOnSelectionReconcileRevision,
    useReviewAnswerJobDoneSync,
    useReviewFeedItemChangedSync,
} from '@/context/reviews-page-transport-realtime.effects';

type UseReviewsPageTransportSyncArgs = {
    accessToken: string;
    clientId: string;
    selectionSessionId: string;
    pickedProducts: string[];
    pickedBrandGroups: string[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    selectionReconcileRevision: number;
    events: SocketIoEvents;
    setSelectionSessionId: (value: string) => void;
    setPickedProducts: (value: string[]) => void;
    setPickedBrandGroups: (value: string[]) => void;
    onReviewAnswerJobDone: (review: ReviewEntity) => void;
    onReviewFeedItemChanged: (review: ReviewEntity) => void;
    refetchReviewsAndProducts: (abort?: AbortSignal) => Promise<void>;
};

export const useReviewsPageTransportSync = ({
    accessToken,
    clientId,
    selectionSessionId,
    pickedProducts,
    pickedBrandGroups,
    products,
    brandGroups,
    selectionReconcileRevision,
    events,
    setSelectionSessionId,
    setPickedProducts,
    setPickedBrandGroups,
    onReviewAnswerJobDone,
    onReviewFeedItemChanged,
    refetchReviewsAndProducts,
}: UseReviewsPageTransportSyncArgs) => {
    useSelectionSessionBootstrap({ clientId, setSelectionSessionId });
    useProductSelectionSessionSync({
        accessToken,
        selectionSessionId,
        pickedProducts,
        setPickedProducts,
    });
    useReviewAnswerJobDoneSync({
        events,
        onReviewAnswerJobDone,
    });
    useReviewFeedItemChangedSync({
        events,
        onReviewFeedItemChanged,
    });
    usePickedProductsReconcile({
        accessToken,
        selectionSessionId,
        pickedProducts,
        products,
        setPickedProducts,
    });
    usePickedBrandGroupsStorageSync({
        clientId,
        pickedBrandGroups,
        setPickedBrandGroups,
    });
    usePickedBrandGroupsReconcile({
        brandGroups,
        pickedBrandGroups,
        setPickedBrandGroups,
    });
    useClientReviewsSyncRefetch({
        events,
        refetchReviewsAndProducts,
    });
    useRefetchOnSelectionReconcileRevision({
        selectionReconcileRevision,
        refetchReviewsAndProducts,
    });
};
